import localeContext from './LocaleContext';
import { formatTemplate } from '../formatter';
export function $l(component, key, defaults, injectionOptions) {
    const locale = localeContext.get(component, key, defaults);
    if (injectionOptions) {
        return formatTemplate(locale, injectionOptions);
    }
    return locale;
}
export default localeContext;
